/* src/app/job-signoff-shredder/partials/job-signoff-shredder-transport/job-signoff-shredder-transport.component.scss */
/*# sourceMappingURL=job-signoff-shredder-transport.component.css.map */
